import React from "react"
import StrategyHeader from "./components/StrategyHeader"
import StrategyAnimation from "./components/StrategyAnimation"
import StyledStrategy from "./styles"

const Strategy = () => {
  return (
    <StyledStrategy>
      <StrategyHeader />
      <StrategyAnimation />
    </StyledStrategy>
  )
}

export default Strategy
